export const humanizeFileName = (s?: string) =>
  (s ?? "")
    .replace(/\.[^/.]+$/, "") // heq extension-in
    .replace(/[_-]+/g, " ") // _ dhe - -> hapësirë
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
